/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import errorImg from '../../images/no-source.png'
import { getAccessToken } from '../../utils'
import { HTTPClient } from '@weike/toolkit'
import configEnv from '@src/config'
const HTTP_SUCCESS = '0000'
const http = new HTTPClient({baseURL: configEnv.BASE_URL_ELSE}, HTTP_SUCCESS)
class LecturerInit extends React.Component {
    componentDidMount() {
        let access_token = getAccessToken()
        let urlData = this.props.urlData;
        this.props.dispatch({
            type: 'SET_INVITE_TARGET_ID',
            payload: urlData
        });
        if (urlData.type === 'lecture'){
            http.get(`/v1/tic/lecture.small_class.get`, {
              params: {
                lecture_id: urlData.target_id,
                token: access_token
              }
            }).then(res => {
                const {data, code} = res
                if(code === HTTP_SUCCESS) {
                  const anchorInfo = data.anchor_info || {}
                  this.props.dispatch({
                      type: 'SET_SMALLCLASS_SPEAKER',
                      payload: anchorInfo.account_id
                  })
                }
              }).catch((error) => {
                console.warn(error)
            });
            axios.get(`/api/lecture/${urlData.target_id}/info`).then(res => {
              if (res.data.code === 0){
                this.props.dispatch({
                    type: 'SET_INVITE_LECTURE_INFO',
                    payload: res.data.data.lecture || {}
                })
              }
                }).catch((error) => {
                  this.abnormalHandler(error)
            });
            axios.get(`/api/lecture/${urlData.target_id}/lecturer/list`)
                .then(res => {
                    if (res.data.code === 0){
                        this.props.dispatch({
                            type: 'LECTURER_INVITE_INIT',
                            payload: res.data.data
                        });
                        this.props.dispatch({
                            type: 'LECTURER_INVITE_APPEND',
                            payload: res.data.data.not_imported_lecturers
                        });
                        this.props.dispatch({
                            type: 'LECTURER_SELECTED_LIST',
                            payload: res.data.data.is_imported_lecturers
                        })
                    }
                }).catch((error) => {
                  this.abnormalHandler(error)
            });
        }
    }
    abnormalHandler(error){
      if (error.response && error.response.status === 404) {
        this.props.dispatch({
            type: 'ERROR_SHOW',
            payload: {
                tips: '网络连接出问题了。',
                img: errorImg,
                href: '/?st=lecturer_invite_404',
                btn: '去首页看看'
            }
        });
      } else if (error.response && error.response.status === 403){
          this.props.dispatch({
              type: 'ERROR_SHOW',
              payload: {
                  tips: '你没有查看此内容的权限',
                  img: errorImg,
                  href: '/?st=lecturer_invite_403',
                  btn: '去首页看看'
              }
          });
      }
    }
    render() {
        return null
    }
}

export default connect()(LecturerInit)


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/LecturerInit.js